$(document).ready(function () {
  let p = $('body').attr('p');

  if (p === 'gift_card') {
    let paymentMethod = '';

    $(document).on('blur', '#recipient-email', function (e) {
      const email = $(this).val();
      if (!isValidEmail(email)) {
        $('#email-error').removeClass('d-none');
      } else {
        $('#email-error').addClass('d-none');
      }
      return;
    });

    $(document).on('click', '.order-button', function (e) {
      e.preventDefault();
      paymentMethod = $(this).attr('data-payment-method');

      $('#gift-card-form').submit();
    });

    $(document).on('click', '.gift-card-amount', function (e) {
      e.preventDefault();
      const giftCardAmount = $(this).attr('data-gift-card-amount');
      $('#gift-card-amount-input')
        .fadeOut(200)
        .queue(function () {
          $(this).val(giftCardAmount).fadeIn(200).dequeue();
        });

      if (!$('#gift-card-amount-alert').hasClass('d-none')) {
        $('#gift-card-amount-alert').addClass('d-none');
      }
    });

    $(document).on('change', '#gift-card-amount-input', function (e) {
      e.preventDefault();
      const giftCardAmount = parseFloat($(this).val());
      const maxAmount = parseFloat($(this).attr('data-max-amount'));
      const minAmount = parseFloat($(this).attr('data-min-amount'));

      if (giftCardAmount > maxAmount) {
        $('#gift-card-amount-alert').text(
          `Beløpet kan ikke være større enn ${maxAmount.toLocaleString(
            'nb-NO',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}.`
        );
        $('#gift-card-amount-alert').removeClass('d-none');
        $(this).focus();
        return;
      } else if (giftCardAmount < minAmount) {
        $('#gift-card-amount-alert').text(
          `Beløpet kan ikke være mindre enn ${minAmount.toLocaleString(
            'nb-NO',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}.`
        );
        $('#gift-card-amount-alert').removeClass('d-none');
        $(this).focus();
        return;
      } else {
        if (!$('#gift-card-amount-alert').hasClass('d-none')) {
          $('#gift-card-amount-alert').addClass('d-none');
        }
        return;
      }
    });

    $(document).on('submit', '#gift-card-form', function (e) {
      e.preventDefault();

      const formData = new FormData(e.target);

      if (!isValidEmail(formData.get('recipient_email'))) {
        $('#email-error').removeClass('d-none');
        $('#recipient-email').focus();
        return;
      }

      if (!checkRequiredFields(formData)) {
        return;
      }

      const giftCardAmountInput = $('#gift-card-amount-input');
      const giftCardAmount = parseFloat($(giftCardAmountInput).val());
      const maxAmount = parseFloat(
        $(giftCardAmountInput).attr('data-max-amount')
      );
      const minAmount = parseFloat(
        $(giftCardAmountInput).attr('data-min-amount')
      );

      if (giftCardAmount > maxAmount) {
        $('#gift-card-amount-alert').text(
          `Beløpet kan ikke være større enn ${maxAmount.toLocaleString(
            'nb-NO',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}.`
        );
        $('#gift-card-amount-alert').removeClass('d-none');
        $(giftCardAmountInput).focus();
        return;
      } else if (giftCardAmount < minAmount) {
        $('#gift-card-amount-alert').text(
          `Beløpet kan ikke være mindre enn ${minAmount.toLocaleString(
            'nb-NO',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}.`
        );
        $('#gift-card-amount-alert').removeClass('d-none');
        $(giftCardAmountInput).focus();
        return;
      } else {
        if (!$('#gift-card-amount-alert').hasClass('d-none')) {
          $('#gift-card-amount-alert').addClass('d-none');
        }
      }

      let api = '/api/v1/gift-card/create';
      if (
        paymentMethod === 'payment_cash' ||
        paymentMethod === 'payment_preprint'
      ) {
        api = '/api/v1/private/gift-card/create';
      }

      formData.append('payment_method', paymentMethod);

      const disabledOnClick = $(
        '#pay_with_cash_for_giftcard, #pay_with_terminal_for_giftcard'
      );
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: 'POST',
        url: api,
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (
            data.payment_redirect_url !== undefined &&
            data.payment_redirect_url !== null
          ) {
            document.location.href = data.payment_redirect_url;
            return;
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    });

    function checkRequiredFields(formData) {
      const requiredFields = ['amount', 'recipient_email', 'phone_number'];
      const missingFields = requiredFields.some(
        (field) => !formData.get(field)
      );

      return true;
    }
  }

  if (p === 'organizer_gift_cards') {
    $(document).on('click', '.send-gift-card-customer-email', function () {
      const orderId = $(this).attr('data-order-id');

      $('#gift-card-order-id').val(orderId);
      $('#resend-gift-card-email').attr('data-order-id', orderId);
      $('#gift-card-send-email-modal').modal('show');
    });
  }

  if (p === 'events') {
    $(document).on('click', '#sell-giftcard-button', function () {
      $('#gift-card-sell-modal')
        .on('shown.bs.modal', function () {
          $(this).find('input[name="gift_card_code"]').trigger('focus');
        })
        .modal('show');
    });

    $(document).on('click', '.check-gift-card-information', function () {
      if (!$('.card-not-found-section').hasClass('d-none')) {
        $('.card-not-found-section').addClass('d-none');
      }

      if (!$('.gift-card-result').hasClass('d-none')) {
        $('.gift-card-result').addClass('d-none');
      }

      const giftCardCode = $('#gift-card-code').val().trim();

      if (!giftCardCode) {
        showToast({
          type: 'warning',
          title: '',
          message: `Vennligst skriv inn gavekortkoden.`,
          position: 'bottom-center',
          duration: 4000,
        });
        $('#gift-card-code').focus();
      }

      $.ajax({
        type: 'POST',
        url: '/api/v1/gift-card/get-status',
        data: {
          code: giftCardCode,
        },
      })
        .done(function (data) {
          if (data && data.invalid_code_message) {
            $('.card-not-found-section').removeClass('d-none');
            $('.card-not-found-section .alert-message').text(
              data.invalid_code_message
            );
          } else if (
            data &&
            data.amount &&
            data.amountLeft &&
            data.expiredDate &&
            data.code
          ) {
            if (data.isActive) {
              if (!$('.expired-badge').hasClass('d-none')) {
                $('.expired-badge').addClass('d-none');
              }
              $('.active-badge').removeClass('d-none');
            } else {
              if (!$('.active-badge').hasClass('d-none')) {
                $('.active-badge').addClass('d-none');
              }
              $('.expired-badge').removeClass('d-none');
            }

            $('.card-number').text(data.code);
            $('.total-amount').text(data.amount);
            $('.amount-left').text(data.amountLeft);
            $('.expired-date').text(data.expiredDate);
            $('.gift-card-result').removeClass('d-none');
          }
        })
        .fail(function (data) {})
        .always(function () {});
    });

    $(document).on('change', 'input[name="amount"][type="radio"]', function () {
      const amount = $(this).val();
      $('#custom-amount').val(amount);
    });

    $(document).on('submit', '#gift-card-selling-form', function (e) {
      e.preventDefault();
      const productPrice = $('#custom-amount').val();
      const giftCardCode =
        $('#new-gift-card-code').val().replace(/\s/g, '') || '';

      if (giftCardCode && giftCardCode.length < 6) {
        showToast({
          type: 'warning',
          title: '',
          message: `Gavekortkoden må være minst 6 tegn lang.`,
          position: 'bottom-center',
          duration: 4000,
        });
        return;
      }

      const proceed = () => {
        const productName = 'Gavekort';
        const product = {
          product_id: `giftcard_${giftCardCode}`,
          amount: 1,
          discount_percent: 0,
          original_product_price: productPrice,
          name: productName,
          is_open_price: 1,
        };
        locationCart.products = [product];
        locationCart.amount = (locationCart.amount || 0) + productPrice;
        locationCart.amount_without_discount =
          (locationCart.amount_without_discount || 0) + productPrice;
        locationCart.number_of_products =
          (locationCart.number_of_products || 0) + 1;

        getClassicCartModal()
          .done(function (data) {
            if (data.cart_products) {
              locationCart.products = data.cart_products;
            }
            $('#tripletex-invoices-button').prop('disabled', true);
            $('#gift-card-sell-modal').modal('hide');
          })
          .fail(function (data) {
            if (data.responseJSON && data.responseJSON.error_message) {
              showToast({
                type: 'warning',
                title: '',
                message: data.responseJSON.error_message,
                position: 'bottom-center',
                duration: 4000,
              });
            }
          })
          .always(function () {
            $('#tripleTaxInvoicesModal').modal('hide');
          });
      };

      // If code is provided, validate it first; otherwise proceed directly
      if (giftCardCode) {
        isValidCode(giftCardCode)
          .done(function () {
            proceed();
          })
          .fail(function (data) {
            const errorMessage =
              data.responseJSON?.error?.message || 'Ugyldig gavekortkode.';
            showToast({
              type: 'warning',
              title: '',
              message: errorMessage,
              position: 'bottom-center',
              duration: 4000,
            });
          });
      } else {
        proceed();
      }
    });

    function isValidCode(giftCardCode) {
      return $.ajax({
        type: 'POST',
        url: '/api/v1/gift-card/new-code-validation',
        data: {
          code: giftCardCode,
        },
      });
    }
  }

  if (p === 'organizer_gift_cards') {
    let locationId = $('body').attr('location_id');

    $(document).on('change', '#select-all-gift-cards', function () {
      const isChecked = $(this).is(':checked');
      const allCheckboxes = $('.gift-card-checkbox');
      allCheckboxes.prop('checked', isChecked);
      if (isChecked) {
        $('.update-giftcard-container').removeClass('d-none');
        const checkedCount = allCheckboxes.filter(':checked').length;
        $('.giftcard-count').text(checkedCount);
      } else {
        $('.update-giftcard-container').addClass('d-none');
        $('.giftcard-count').text(0);
      }
    });

    $(document).on('change', '.gift-card-checkbox', function () {
      const allCheckboxes = $('.gift-card-checkbox');
      const allChecked =
        allCheckboxes.length === allCheckboxes.filter(':checked').length;
      $('#select-all-gift-cards').prop('checked', allChecked);
      const anyChecked = allCheckboxes.filter(':checked').length > 0;
      const checkedCount = allCheckboxes.filter(':checked').length;
      if (anyChecked) {
        $('.update-giftcard-container').removeClass('d-none');
        $('.giftcard-count').text(checkedCount);
      } else {
        $('.update-giftcard-container').addClass('d-none');
        $('.giftcard-count').text(0);
      }
    });

    $(document).on('click', '#update-expired-date-button', function (e) {
      e.preventDefault();
      const selectedGiftCardIds = $('.gift-card-checkbox:checked')
        .map(function () {
          return $(this).data('gift-card-id');
        })
        .get();

      const newExpiredDate = $('#update-expired-date').val();
      console.log(selectedGiftCardIds, newExpiredDate);
      if (selectedGiftCardIds.length === 0) {
        showToast({
          type: 'warning',
          title: 'Ingen gavekort valgt',
          message: `Vennligst velg minst ett gavekort.`,
          position: 'bottom-center',
          duration: 4000,
        });
        return;
      }
      if (selectedGiftCardIds.length === 0) {
        showToast({
          type: 'warning',
          title: 'Ingen utløpsdato',
          message: ` Vennligst angi en ny utløpsdato.`,
          position: 'bottom-center',
          duration: 4000,
        });
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/gift-card/update-expired-date',
        data: {
          gift_card_ids: selectedGiftCardIds,
          new_expired_date: newExpiredDate,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data.success && data.html) {
            showToast({
              type: 'success',
              title: '',
              message: `Utløpsdatoen for de valgte gavekortene ble oppdatert.`,
              position: 'bottom-center',
              duration: 4000,
            });
            $('#gift-card-list').empty().append(data.html);
            $('#select-all-gift-cards').prop('checked', false);
            $('.update-giftcard-container').addClass('d-none');
            $('.giftcard-count').text(0);
          }
        })
        .fail(function (data) {
          const errorMessage =
            data.responseJSON?.error?.message ||
            'Noe gikk galt. Vennligst prøv igjen.';
          showToast({
            type: 'warning',
            title: '',
            message: errorMessage,
            position: 'bottom-center',
            duration: 4000,
          });
        });
    });
  }
});
